export const kannadaFlashcards = {
  categories: [
    {
      kn: "ನಮಸ್ಕಾರ",
      rm: "Namaskara",
      en: "Hello / Greetings",
    },
    {
      kn: "ಹೇಗಿದ್ದೀರಿ?",
      rm: "Hegiddiri?",
      en: "How are you? (formal)",
    },
    {
      kn: "ಹೇಗಿದ್ದೀರಾ?",
      rm: "Hegiddiraa?",
      en: "How are you? (more formal, respectful)",
    },
    {
      kn: "ಹೇಗಿದ್ದೀಯ?",
      rm: "Hegiddiya?",
      en: "How are you? (informal)",
    },
    {
      kn: "ನಾನು ಚೆನ್ನಾಗಿದ್ದೀನಿ",
      rm: "Naanu chennagiddini",
      en: "I am fine",
    },
    {
      kn: "ಧನ್ಯವಾದಗಳು",
      rm: "Dhanyavaadagalu",
      en: "Thank you",
    },
    {
      kn: "ತುಂಬಾ ಧನ್ಯವಾದಗಳು",
      rm: "Tumbaa dhanyavaadagalu",
      en: "Thank you very much",
    },
    {
      kn: "ಪರವಾಗಿಲ್ಲ",
      rm: "Paravaagilla",
      en: "You're welcome / It's okay / Never mind",
    },
    {
      kn: "ಕ್ಷಮಿಸಿ",
      rm: "Kshamisi",
      en: "Excuse me / Sorry",
    },
    {
      kn: "ದಯವಿಟ್ಟು",
      rm: "Dayavittu",
      en: "Please",
    },
    {
      kn: "ಹೌದು",
      rm: "Haudu",
      en: "Yes",
    },
    {
      kn: "ಇಲ್ಲ",
      rm: "Illa",
      en: "No",
    },
    {
      kn: "ಸರಿ",
      rm: "Sari",
      en: "Okay / Alright",
    },
    {
      kn: "ನನಗೆ ಅರ್ಥವಾಗಲಿಲ್ಲ",
      rm: "Nanage arthavagalilla",
      en: "I don't understand",
    },
    {
      kn: "ನಿಮಗೆ ಇಂಗ್ಲಿಷ್ ಗೊತ್ತಾ?",
      rm: "Nimge English gottaa?",
      en: "Do you know English?",
    },
    {
      kn: "ಇದು ಏನು?",
      rm: "Idu yenu?",
      en: "What is this?",
    },
    {
      kn: "ಇದು ಎಷ್ಟು?",
      rm: "Idu eshtu?",
      en: "How much is this?",
    },
    {
      kn: "ಎಲ್ಲಿ ಇದೆ?",
      rm: "Elli ide?",
      en: "Where is...?",
    },
    {
      kn: "ಟಾಯ್ಲೆಟ್ ಎಲ್ಲಿ ಇದೆ?",
      rm: "Toilet elli ide?",
      en: "Where is the toilet?",
    },
    {
      kn: "ರೈಲು ನಿಲ್ದಾಣ ಎಲ್ಲಿ ಇದೆ?",
      rm: "Railu nildhaana elli ide?",
      en: "Where is the railway station?",
    },
    {
      kn: "ವಿಮಾನ ನಿಲ್ದಾಣ ಎಲ್ಲಿ ಇದೆ?",
      rm: "Vimaana nildhaana elli ide?",
      en: "Where is the airport?",
    },
    {
      kn: "ಆಸ್ಪತ್ರೆ ಎಲ್ಲಿ ಇದೆ?",
      rm: "Aaspatre elli ide?",
      en: "Where is the hospital?",
    },
    {
      kn: "ಸಹಾಯ ಮಾಡಿ!",
      rm: "Sahaya maadi!",
      en: "Help!",
    },
    {
      kn: "ಪೊಲೀಸ್!",
      rm: "Police!",
      en: "Police!",
    },
    {
      kn: "ನನಗೆ ಸಹಾಯ ಬೇಕು",
      rm: "Nanage sahaya beku",
      en: "I need help",
    },
    {
      kn: "ನಾನು ಕಳೆದುಹೋಗಿದ್ದೇನೆ",
      rm: "Naanu kaleduhogiddene",
      en: "I am lost",
    },
    {
      kn: "ನೀವು ನನಗೆ ಸಹಾಯ ಮಾಡಬಹುದಾ?",
      rm: "Neevu nanage sahaya maadabahudaa?",
      en: "Can you help me?",
    },
    {
      kn: "ನಿಧಾನವಾಗಿ ಮಾತನಾಡಿ",
      rm: "Nidhaanavaagi maatanaadi",
      en: "Speak slowly",
    },
    {
      kn: "ಮತ್ತೊಮ್ಮೆ ಹೇಳಿ",
      rm: "Mattonme heli",
      en: "Say it again",
    },
    {
      kn: "ನನಗೆ ಹುಷಾರಿಲ್ಲ",
      rm: "Nanage hushaarilla",
      en: "I am not feeling well / I am sick",
    },
    {
      kn: "ನನಗೆ ಡಾಕ್ಟರ್ ಬೇಕು",
      rm: "Nanage doctor beku",
      en: "I need a doctor",
    },
    {
      kn: "ಇದು ತುಂಬಾ ದುಬಾರಿ",
      rm: "Idu tumbaa dubaari",
      en: "This is too expensive",
    },
    {
      kn: "ಸ್ವಲ್ಪ ಕಡಿಮೆ ಮಾಡ್ತೀರಾ?",
      rm: "Swalpa kadime maadthiraa?",
      en: "Can you lower the price?",
    },
    {
      kn: "ನನಗೆ ಇದು ಬೇಕು",
      rm: "Nanage idu beku",
      en: "I want this",
    },
    {
      kn: "ನನಗೆ ಇದು ಬೇಡ",
      rm: "Nanage idu beda",
      en: "I don't want this",
    },
    {
      kn: "ನನ್ನ ಹೆಸರು...",
      rm: "Nanna hesaru...",
      en: "My name is...",
    },
    {
      kn: "ನೀವು ಹೇಗಿದ್ದೀರಿ?",
      rm: "Neevu hege iddiri?",
      en: "How are you? (formal)",
    },
    {
      kn: "ಏನ್ ಸಮಾಚಾರ?",
      rm: "En samaachaara?",
      en: "What's up? (informal)",
    },
    {
      kn: "ಚೆನ್ನಾಗಿದ್ದೀನಿ, ಧನ್ಯವಾದಗಳು",
      rm: "Chennagiddini, dhanyavaadagalu",
      en: "I am fine, thank you",
    },
    {
      kn: "ಚೆನ್ನಾಗಿದೆ",
      rm: "Chennagide",
      en: "It's good",
    },
    {
      kn: "ತುಂಬಾ ಚೆನ್ನಾಗಿದೆ",
      rm: "Tumbaa chennagide",
      en: "Very good",
    },
    {
      kn: "ಕೆಟ್ಟದಾಗಿದೆ",
      rm: "Kettadaagide",
      en: "It's bad",
    },
    {
      kn: "ಶುಭೋದಯ",
      rm: "Shubhodaya",
      en: "Good morning",
    },
    {
      kn: "ಶುಭ ಮಧ್ಯಾಹ್ನ",
      rm: "Shubha madhyaahna",
      en: "Good afternoon",
    },
    {
      kn: "ಶುಭ ಸಾಯಂಕಾಲ",
      rm: "Shubha saayankaala",
      en: "Good evening",
    },
    {
      kn: "ಶುಭ ರಾತ್ರಿ",
      rm: "Shubha raatri",
      en: "Good night",
    },
    {
      kn: "ಹೋಗಿ ಬನ್ನಿ",
      rm: "Hogi banni",
      en: "Goodbye",
    },
    {
      kn: "ಮತ್ತೆ ಸಿಗೋಣ",
      rm: "Matte sigona",
      en: "See you again",
    },
    {
      kn: "ಬಲಕ್ಕೆ",
      rm: "Balakke",
      en: "To the right",
    },
    {
      kn: "ಎಡಕ್ಕೆ",
      rm: "Edakke",
      en: "To the left",
    },
    {
      kn: "ನೇರವಾಗಿ",
      rm: "Neravaagi",
      en: "Straight ahead",
    },
    {
      kn: "ಮೇಲೆ",
      rm: "Mele",
      en: "Up",
    },
    {
      kn: "ಕೆಳಗೆ",
      rm: "Kelage",
      en: "Down",
    },
    {
      kn: "ಸಮೀಪದಲ್ಲಿ",
      rm: "Sameepdalli",
      en: "Near",
    },
    {
      kn: "ದೂರದಲ್ಲಿ",
      rm: "Dooradalli",
      en: "Far",
    },
    {
      kn: "ಇಂದು",
      rm: "Indu",
      en: "Today",
    },
    {
      kn: "ನಾಳೆ",
      rm: "Naale",
      en: "Tomorrow",
    },
    {
      kn: "ನಿನ್ನೆ",
      rm: "Ninne",
      en: "Yesterday",
    },
    {
      kn: "ಈಗ",
      rm: "Iga",
      en: "Now",
    },
    {
      kn: "ನಂತರ",
      rm: "Nantara",
      en: "Later",
    },
    {
      kn: "ಬೆಳಿಗ್ಗೆ",
      rm: "Beligge",
      en: "Morning",
    },
    {
      kn: "ಮಧ್ಯಾಹ್ನ",
      rm: "Madhyaahna",
      en: "Afternoon",
    },
    {
      kn: "ಸಂಜೆ",
      rm: "Sanje",
      en: "Evening",
    },
    {
      kn: "ರಾತ್ರಿ",
      rm: "Ratri",
      en: "Night",
    },
    {
      kn: "ನೀರು",
      rm: "Neeru",
      en: "Water",
    },
    {
      kn: "ಊಟ",
      rm: "Oota",
      en: "Food",
    },
    {
      kn: "ಚಹಾ",
      rm: "Chaha",
      en: "Tea",
    },
    {
      kn: "ಕಾಫಿ",
      rm: "Kaafi",
      en: "Coffee",
    },
    {
      kn: "ಬಿಯರ್",
      rm: "Biyar",
      en: "Beer",
    },
    {
      kn: "ಮದ್ಯ",
      rm: "Madya",
      en: "Alcohol",
    },
    {
      kn: "ಸಸ್ಯಾಹಾರಿ",
      rm: "Sasyaahaari",
      en: "Vegetarian",
    },
    {
      kn: "ಮಾಂಸಾಹಾರಿ",
      rm: "Maamsaahaari",
      en: "Non-vegetarian",
    },
    {
      kn: "ಇದು ಸಸ್ಯಾಹಾರಿನಾ?",
      rm: "Idu sasyaahaarinaa?",
      en: "Is this vegetarian?",
    },
    {
      kn: "ನನಗೆ ಹಸಿವಾಗುತ್ತಿದೆ",
      rm: "Nanage hasivaaguttide",
      en: "I am hungry",
    },
    {
      kn: "ನನಗೆ ಬಾಯಾರಿಕೆಯಾಗುತ್ತಿದೆ",
      rm: "Nanage baayarikeyaguttide",
      en: "I am thirsty",
    },
    {
      kn: "ಎಷ್ಟು ಸಮಯ ತೆಗೆದುಕೊಳ್ಳುತ್ತದೆ?",
      rm: "Eshtu samaya tegedukolluttade?",
      en: "How much time will it take?",
    },
    {
      kn: "ಪಾಸ್ಪೋರ್ಟ್",
      rm: "Passport",
      en: "Passport",
    },
    {
      kn: "ವೀಸಾ",
      rm: "Visa",
      en: "Visa",
    },
    {
      kn: "ಟಿಕೆಟ್",
      rm: "Ticket",
      en: "Ticket",
    },
    {
      kn: "ಹೋಟೆಲ್",
      rm: "Hotel",
      en: "Hotel",
    },
    {
      kn: "ಕೊಠಡಿ",
      rm: "Kothadi",
      en: "Room",
    },
    {
      kn: "ನಾನು ಒಂದು ಕೊಠಡಿ ಬುಕ್ ಮಾಡಲು ಬಯಸುತ್ತೇನೆ",
      rm: "Naanu ondu kothadi book maadalu bayasuttene",
      en: "I want to book a room",
    },
    {
      kn: "ಇದು ತುಂಬಾ ಚೆನ್ನಾಗಿದೆ",
      rm: "Idu tumbaa chennagide",
      en: "This is very good",
    },
    {
      kn: "ಇದು ತುಂಬಾ ಕೆಟ್ಟದಾಗಿದೆ",
      rm: "Idu tumbaa kettadaagide",
      en: "This is very bad",
    },
    {
      kn: "ಯಾವ ತೊಂದರೆಯಿಲ್ಲ",
      rm: "Yaava tondare illa",
      en: "No problem",
    },
    {
      kn: "ಶುಭಾಶಯಗಳು",
      rm: "Shubhaashayagalu",
      en: "Best wishes / Congratulations",
    },
    {
      kn: "ಸಂತೋಷವಾಗಿರಿ",
      rm: "Santoshavagiri",
      en: "Have fun",
    },
    {
      kn: "ತಿಂಡಿ ತಿನ್ನಿ",
      rm: "Tindi tinni",
      en: "Please eat (formal)",
    },
    {
      kn: "ಬೇಗ ಬಾ",
      rm: "Bega baa",
      en: "Come quickly",
    },
    {
      kn: "ನೋಡಿ ಕಲಿ",
      rm: "Nodi kali",
      en: "Watch and learn",
    },
    {
      kn: "ಇಲ್ಲಿ ಬನ್ನಿ",
      rm: "Illi banni",
      en: "Come here",
    },
  ],
};
